import { render, staticRenderFns } from "./RadioColor.vue?vue&type=template&id=877b240c&"
import script from "./RadioColor.vue?vue&type=script&lang=js&"
export * from "./RadioColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports